import React from 'react';
import TableCell from '@mui/material/TableCell';

type HeatmapCellCommonProps = {
  value: number;
  color: string | null;
};

type VerticalHeatmapCellProps = HeatmapCellCommonProps & {
  orientation: 'vertical';
  roundTop?: boolean;
  roundBottom?: boolean;
};

type HorizontalHeatmapCellProps = HeatmapCellCommonProps & {
  orientation: 'horizontal';
  roundLeft?: boolean;
  roundRight?: boolean;
};

type HeatmapCellProps = VerticalHeatmapCellProps | HorizontalHeatmapCellProps;

export const HeatmapCell: React.FC<HeatmapCellProps> = (props) => {
  const { value, color, orientation } = props;

  const isVertical = orientation === 'vertical';

  const paddingStyle = isVertical
    ? {
        paddingTop: props.roundTop ? '6px' : 0,
        paddingBottom: props.roundBottom ? '6px' : 0,
      }
    : {
        paddingLeft: props.roundLeft ? '6px' : 0,
        paddingRight: props.roundRight ? '6px' : 0,
      };

  const borderRadiusStyle = isVertical
    ? {
        ...(props.roundTop && { borderTopLeftRadius: '40px', borderTopRightRadius: '40px' }),
        ...(props.roundBottom && { borderBottomLeftRadius: '40px', borderBottomRightRadius: '40px' }),
      }
    : {
        ...(props.roundLeft && { borderTopLeftRadius: '40px', borderBottomLeftRadius: '40px' }),
        ...(props.roundRight && { borderTopRightRadius: '40px', borderBottomRightRadius: '40px' }),
      };

  const cellContentStyle: React.CSSProperties = {
    ...borderRadiusStyle,
    width: isVertical ? '50px' : '100%',
    minWidth: isVertical ? undefined : '60px',
    height: '50px',
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(color ? { backgroundColor: color } : {}),
  };

  return (
    <TableCell
      style={{ whiteSpace: 'pre-wrap', width: isVertical ? '25%' : undefined, ...paddingStyle, backgroundColor: 'var(--color-element)' }}
      align="center"
    >
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <div style={cellContentStyle}>{`${value.toFixed(2)}\r\n zł/kWh`}</div>
      </div>
    </TableCell>
  );
};
